import OpenAI from 'openai';

// Check if OpenAI is configured
export function isOpenAIConfigured() {
  return !!import.meta.env.VITE_OPENAI_API_KEY;
}

// Get OpenAI client instance
export function getOpenAIClient() {
  if (!isOpenAIConfigured()) {
    throw new Error('OpenAI API key is not configured');
  }
  
  return new OpenAI({
    apiKey: import.meta.env.VITE_OPENAI_API_KEY,
    dangerouslyAllowBrowser: true
  });
}

// Lightweight client; uses browser key (ok for now; swap to proxy later if needed)
export async function generateJSON(system, user) {
  const resp = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${import.meta.env.VITE_OPENAI_API_KEY}`,
    },
    body: JSON.stringify({
      model: "gpt-4o-mini",
      response_format: { type: "json_object" },
      messages: [
        { role: "system", content: system },
        { role: "user", content: user },
      ],
      temperature: 0.6,
    }),
  });
  if (!resp.ok) throw new Error(`OpenAI error ${resp.status}`);
  const data = await resp.json();
  const raw = data.choices?.[0]?.message?.content ?? "{}";
  return JSON.parse(raw);
}